
import { defineComponent, onMounted, computed, ref, watchEffect } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";
import objectPath from "object-path";

export default defineComponent({
  name: "business-details",
  components: {
    // FundingRounds,
  },
  setup() {
    const loading = ref<boolean>(false);
    const user = computed(() => store.getters.getUser);
    const hasFounderRole = computed(() => {
      return user.value?.userRoles?.some(
        (role) => role.name.toLowerCase() == "founder"
      );
    });
    const op = computed(() => objectPath);
    const store = useStore();
    const route = useRoute();
    const expert = ref<Record<string, unknown>>({});
    const founderRequisiteExperts = ref<Array<Record<string, unknown>>>([]);
    watchEffect(() => {
      founderRequisiteExperts.value = user.value.founderRequisiteExpert;
    });
    const isConnected = computed(() => {
      return founderRequisiteExperts.value.some((expert) => {
        return (
          objectPath.get(expert, "id", false) ==
          (route.params.id as string | boolean)
        );
      });
    });
    const toUpperCase = (value) => {
      return value?.toUpperCase();
    };
    const parseJSON = (value) => {
      return value ? JSON.parse(value) : [];
    };
    const arrayStringConstructor = (arr) => {
      let arrayString = "";
      for (let i = 0; i < arr.length; i++) {
        arrayString = arrayString + `${arr[i].name}${arr[i + 1] ? ", " : ""}`;
      }
      return arrayString;
    };
    const attachExpert = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          Actions.FOUNDER_REQUISITE_EXPERT,
          {
            expertId: route.params.id,
          }
        );
        if (response !== true) throw new Error();
        store.dispatch(Actions.AUTH_USER);
        loading.value = false;
        store.commit("setAlert", {
          message: "Success",
          subMessage: "A Request has been sent to the expert",
          variant: "primary",
          duration: 4000,
          show: true,
        });
      } catch (err) {
        loading.value = false;
        store.commit("setAlert", {
          message: "Error",
          subMessage:
            "Sorry, looks like there are some errors detected, please try again.",
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    onMounted(async () => {
      try {
        const response = await store.dispatch(
          Actions.GET_EXPERT_PROFILE_GLOBAL,
          route.params.id
        );
        if (!response.success) throw new Error();
        expert.value = response.data;
      } catch (err) {
        console.log(err);
      }
      setCurrentPageBreadcrumbs("Expert Profile", [
        "Find Investment Opportunities",
      ]);
    });
    return {
      loading,
      isConnected,
      attachExpert,
      toUpperCase,
      parseJSON,
      route,
      expert,
      op,
      arrayStringConstructor,
      hasFounderRole,
    };
  },
});
